import type * as ET from './EntityTypes';

// A type map: each property's type is an entity, and the class exists so `Object.keys(new
// AllEntities())` lists the entity names at runtime (API.ts, Data/schemas.ts). The values are never
// read, so every property is an `undefined` placeholder typed as its entity.
const placeholder = <T>() => undefined as unknown as T;

class AllEntities {
    Agency = placeholder<ET.Agency>();

    Alert = placeholder<ET.Alert>();

    Buyer = placeholder<ET.Buyer>();

    BuyerCost = placeholder<ET.BuyerCost>();

    Campaign = placeholder<ET.Campaign>();

    CampaignDisplay = placeholder<ET.CampaignDisplay>();

    CampaignInstruction = placeholder<ET.CampaignInstruction>();

    CampaignReporting = placeholder<ET.CampaignReporting>();

    CampaignOwnerContactedDate = placeholder<ET.CampaignOwnerContactedDate>();

    CampaignPopShot = placeholder<ET.CampaignPopShot>();

    Creative = placeholder<ET.Creative>();

    CreativeGroup = placeholder<ET.CreativeGroup>();

    Client = placeholder<ET.Client>();

    Date = placeholder<ET.Date>();

    Display = placeholder<ET.Display>();

    File = placeholder<ET.File>();

    Market = placeholder<ET.Market>();

    MissingDisplay = placeholder<ET.MissingDisplay>();

    Note = placeholder<ET.Note>();

    NotificationReport = placeholder<ET.NotificationReport>();

    Owner = placeholder<ET.Owner>();

    Pack = placeholder<ET.Pack>();

    Pca = placeholder<ET.Pca>();

    Permission = placeholder<ET.Permission>();

    Post = placeholder<ET.Post>();

    Request = placeholder<ET.Request>();

    Resolution = placeholder<ET.Resolution>();

    Role = placeholder<ET.Role>();

    Rule = placeholder<ET.Rule>();

    Schedule: ET.Schedule;

    SpotlightRecentResource = placeholder<ET.SpotlightRecentResource>();

    Stream = placeholder<ET.Stream>();

    Skin = placeholder<ET.Skin>();

    User = placeholder<ET.User>();

    DataStatusLineItems = placeholder<ET.DataStatusLineItems>();

    Displays_AudienceFallback = placeholder<ET.Displays_AudienceFallback>();

    Displays_AnalogueScreen = placeholder<ET.Displays_AnalogueScreen>();

    Displays_AudienceUpload = placeholder<ET.Displays_AudienceUpload>();

    Displays_AudienceSource = placeholder<ET.Displays_AudienceSource>();

    Displays_AudienceVersion = placeholder<ET.Displays_AudienceVersion>();

    Displays_Country = placeholder<ET.Displays_Country>();

    Displays_Currency = placeholder<ET.Displays_Currency>();

    Displays_DisplayIssues = placeholder<ET.Displays_DisplayIssues>();

    Displays_FrameType = placeholder<ET.Displays_FrameType>();

    Displays_Market = placeholder<ET.Displays_Market>();

    Displays_OperationalTime = placeholder<ET.Displays_OperationalTime>();

    Displays_Owner = placeholder<ET.Displays_Owner>();

    Displays_Pack = placeholder<ET.Displays_Pack>();

    Displays_Partner = placeholder<ET.Displays_Partner>();

    Displays_Screen = placeholder<ET.Displays_Screen>();

    Displays_LineItem = placeholder<ET.Displays_LineItem>();

    Displays_Tag = placeholder<ET.Displays_Tag>();

    Displays_FileType = placeholder<ET.Displays_FileType>();

    Displays_Vendor = placeholder<ET.Displays_Vendor>();

    PopDisplays_ChannelFrame = placeholder<ET.PopDisplays_ChannelFrame>();

    PopDisplays_Display = placeholder<ET.PopDisplays_Display>();

    PopDisplays_GraphReportType = placeholder<ET.PopDisplays_GraphReportType>();

    PopDisplays_JobStatus = placeholder<ET.PopDisplays_JobStatus>();

    PopDisplays_LogFileImport = placeholder<ET.PopDisplays_LogFileImport>();

    PopDisplays_LogFileParsed = placeholder<ET.PopDisplays_LogFileParsed>();

    PopDisplays_LogFileResource = placeholder<ET.PopDisplays_LogFileResource>();

    PopDisplays_LogImportSource = placeholder<ET.PopDisplays_LogImportSource>();

    PopDisplays_LogFileImportSummary = placeholder<ET.PopDisplays_LogFileImportSummary>();

    PopDisplays_LogSourceAccount = placeholder<ET.PopDisplays_LogSourceAccount>();

    PopDisplays_LogSourceCampaignIdentifier =
        placeholder<ET.PopDisplays_LogSourceCampaignIdentifier>();

    PopDisplays_Market = placeholder<ET.PopDisplays_Market>();

    PopDisplays_Media = placeholder<ET.PopDisplays_Media>();

    Campaign_Chat = placeholder<ET.Campaign_Chat>();
}

export type AnEntity = AllEntities[keyof AllEntities];

type EntityName<Entity extends AnEntity> = ({ name: keyof AllEntities } & {
    [key in keyof AllEntities as AllEntities[key] extends Entity ? 'name' : never]: key;
})['name'];

export default AllEntities;
